<template>
    <transition appear name="fade-transition">
        <div v-if="app" class="app-logo pt-5 pb-4 pr-4">
            <router-link v-test-id="`platform-logo-link`" :to="to" :title="$t('go_home')">
                <app-image
                    :alt="$t('go_home')"
                    :src="src"
                    contain
                    height="100%"
                    width="100%"
                    min-width="11rem"
                    position="center left"
                />
            </router-link>
        </div>
        <div v-else class="app-logo">
            <v-img
                :alt="$t('logo')"
                :src="src"
                contain
                height="100%"
                width="100%"
                min-width="11rem"
                position="center left"
            />
        </div>
    </transition>
</template>

<script>
export default {
    name: 'AppLogo',
    props: {
        app: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        src: require('@/images/default_logo.svg')
    }),
    computed: {
        to() {
            const to = this.home_route;

            if (to && this.$route.fullPath === to.fullPath) {
                return null;
            }

            return to;
        }
    },
    methods: {
        setup() {
            const logo = this.Auth().branding().image('logo');
            if (logo) {
                this.src = logo;
            }
        }
    }
};
</script>
